import { render } from "./PostsViewOptions.vue?vue&type=template&id=4059b28a&ts=true"
import script from "./PostsViewOptions.vue?vue&type=script&lang=ts"
export * from "./PostsViewOptions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__